import { Divider, Grid, Typography } from "@mui/material"
import { StyledPaper } from "../commons"
import { RewardsIcon } from "../../assets"
// import { useNavigate } from "react-router-dom"

const PointsPopover = () => {
  // const navigate = useNavigate()
  return (
    <StyledPaper color='primary'
      transparent
      sx={{
        padding: { xs: '2rem 2rem', sm: '1rem 1rem' },
        minWidth: '14rem',
        maxWidth: { xs: '100%', sm: '14rem' },
        // maxWidth: { xs: '100%', sm: '100%' },
        // minHeight: { xs: '5rem', sm: '6rem' },
        width: '100%',
        height: '100%',
        borderRadius: 1,
      }}>
      <Grid container gap={2} justifyItems={'center'} alignItems={'center'}>
        <Grid item container sx={{ placeContent: 'center' }} xs={12}>
          <Typography variant='h3' color='text.secondary'>
            MEME POINTS
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Grid container item sx={{ placeContent: 'center' }} alignItems={'center'} justifyItems={'center'}>
            <Typography variant="h4" color='brand.primary' component={'span'} sx={{ marginLeft: '0.5rem' }}>
              100
            </Typography>
            <RewardsIcon style={{ height: '2rem', width: '2rem', marginLeft: '0.2rem' }} />
          </Grid>
        </Grid>
        <Divider sx={{ backgroundColor: 'text.secondary', width: '100%' }} />
        <Grid container item sx={{ placeContent: 'center' }} xs={12}>
          <Grid item container justifyContent={"space-between"}>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">Rank</Typography>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">100</Typography>
          </Grid>
          <Grid item container justifyContent={"space-between"}>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">Deposit Points</Typography>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">100</Typography>
          </Grid>
          <Grid item container justifyContent={"space-between"}>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">Borrow Points</Typography>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">100</Typography>
          </Grid>
          <Grid item container justifyContent={"space-between"}>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">Referral Points</Typography>
            <Typography sx={{ color: 'text.secondary' }} variant="xs">100</Typography>
          </Grid>
        </Grid>
        <Divider sx={{ backgroundColor: 'text.secondary', width: '100%' }} />
        <Grid container item sx={{ placeContent: 'center' }} xs={12}>
          {/* <Button onClick={() => navigate(`${siteMap.rewards.path}`)} color="secondary" variant='contained' sx={{ padding: '0.5rem 1.5rem', width: '100%', zIndex: 99 }}>
            <Typography variant="xs">
              View Leaderboard
            </Typography>
          </Button> */}
        </Grid>
      </Grid>
    </StyledPaper>
  )
}

export default PointsPopover